import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import popSound from '../../../../assets/sounds/pop.wav';
import { CitiesService } from '../../cities/services/cities.service';

@Injectable({
  providedIn: 'root'
})
export class SseService {
    constructor(
      private zone: NgZone,
      private citiesService: CitiesService
    ) {}

    userSelectedCityId = this.citiesService.getUserSelectedCityId();
  
    getServerSentEvent(url: string): Observable<MessageEvent> {
      return new Observable(observer => {
       
        const eventSource = new EventSource(url);
  
        eventSource.onmessage = (event) => {
          this.zone.run(() => {
            this.playNotificationSound();
            observer.next(event);
          });
        };
  
        eventSource.onerror = (error) => {
          this.zone.run(() => {
            console.error('Error en SSE:', error);
            observer.error(error);
          });
        };
  
        return () => {
          eventSource.close();
        };
      });
    }

    playNotificationSound() {
      const audio = new Audio(popSound);
      audio.play();
    }
  }